import {Entity} from "../helpers/Entity"


export type InvoiceImportableDto = {
    saleId: string
    invoiceID: string
    invoiceIdentifier: string
    contactID: string
    customerID: string
    customerFirstName: string
    customerLastName: string
    createTime: string
    ticketNumber: string
    type: string
    isImportable: boolean
    applyPayments: boolean
    amount: string
    isVoided: boolean
    integrationKey: string

}

export default class InvoiceImportable implements Entity {
    private dto: InvoiceImportableDto

    constructor(dto: InvoiceImportableDto) {
        this.dto = dto
    }

    isLoaded() {
        return this.dto.saleId != ""
    }

    getId() {
        return this.dto.saleId
    }

    getDto(){
        return this.dto
    }
}



// WEBPACK FOOTER //
// ./src/state/integration/InvoiceImportable.ts